module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.survey) ? _c('div', {
    staticClass: "header_main"
  }, [_c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('router-link', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "to": {
        path: '/BuildingSurvey/' + _vm.survey.buildingSurveyId
      },
      "tag": "a"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "header_label"
  }, [_vm._v("Survey Name")]), _vm._v(" "), _c('span', {
    staticClass: "header_value"
  }, [_vm._v(_vm._s(_vm.survey.surveyName))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-525ea32e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyHeader.vue
// module id = 938
// module chunks = 1